import React, { useContext, useState, useEffect } from 'react';
import { ConnectionContext, getAPIImage, displayLoader, getMatchURL } from '../utils';
import { TeamLogo } from './teamLogo';



/**
 * Small Matchbox Component: Alt layout used for live matches in widgets
 */
const SmallMatchBoxAlt = (props) => {
    const { 
        data = null,
        link   = '#',
        ...restProps 
    } = props;
    if ( !data ) return;

    let classes = 'smallMatchAlt';

    return (
        <a href={getMatchURL(data.id)} className={classes}>

            <div className="smallMatchAlt__team">
                <TeamLogo defaultPictureId={ data.homeTeam.hasOwnProperty('picture') ? data.homeTeam.picture : null } fallback={(<h5 className="smallMatchAlt__teamName">{data.homeTeam.name}</h5>)} />
            </div>

            <div className="smallMatchAlt__main">
                <h5 className="smallMatchAlt__competition">{data.competition.name}</h5>
                <div className="smallMatchAlt__stats">
                    <span className="smallMatchAlt__stat">{data.homeTeamResult.current}</span>
                    <span className="smallMatchAlt__time">{data.currentMinute}</span>
                    <span className="smallMatchAlt__stat">{data.awayTeamResult.current}</span>
                </div>
            </div>

            <div className="smallMatchAlt__team">
                <TeamLogo defaultPictureId={ data.awayTeam.hasOwnProperty('picture') ? data.awayTeam.picture : null } fallback={(<h5 className="smallMatchAlt__teamName">{data.awayTeam.name}</h5>)} />
            </div>

        </a>
    );
}



/**
 * Export
 */
export { SmallMatchBoxAlt };